// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nu3jejMLELOKrJEkYL7-xw\\=\\={height:176px}html[dir] .nu3jejMLELOKrJEkYL7-xw\\=\\={margin:12px 12px 8px 12px}html[dir] ._0eQpwyr3VTwDvU8sEFQhUA\\=\\={text-align:center}.rBN-9FLKigxpGNNp3mGLEQ\\=\\={display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%}", ""]);
// Exports
exports.locals = {
	"campaign": "nu3jejMLELOKrJEkYL7-xw==",
	"textContainer": "_0eQpwyr3VTwDvU8sEFQhUA==",
	"messageAndImageContainer": "rBN-9FLKigxpGNNp3mGLEQ=="
};
module.exports = exports;
